<template>
    <div v-if="type_id === 800" class="mt-2 mb-2">
        <b-card class="w-100" header-tag="header">
            <template #header>
                <b-row>
                    <b-col class="col-12 text-start">
                        <span><small><i class="fas fa-person-chalkboard"></i> <b>{{ title }}</b></small></span>
                    </b-col>
                </b-row>
            </template>
            <b-card-body v-if="widgetData !== null">
                <div class="d-flex w-100 justify-content-between">
                    <div class="numberCircle bg-primary-custom text-white"
                         @click="toIndex(widgetData.resources.resource_ids[0])">
                        {{ widgetData.resources.status_overview[0] }}<br><small class="fsmall">{{
                            $t('Unconf')
                        }}</small></div>
                    <div class="numberCircle bg-ok text-white" @click="toIndex(widgetData.resources.resource_ids[1])">
                        {{ widgetData.resources.status_overview[1] }}<br><small class="fsmall">{{ $t('Ok') }}</small>
                    </div>
                    <div class="numberCircle bg-warning text-white"
                         @click="toIndex(widgetData.resources.resource_ids[2])">
                        {{ widgetData.resources.status_overview[2] }}<br><small class="fsmall">{{ $t('Warn') }}</small>
                    </div>
                    <div class="numberCircle bg-critical text-white"
                         @click="toIndex(widgetData.resources.resource_ids[3])">
                        {{ widgetData.resources.status_overview[3] }}<br><small class="fsmall">{{ $t('Crit') }}</small>
                    </div>
                </div>
                <b-accordion class="mt-2">
                    <b-accordion-item v-for="deadline in deadlines">
                        <template #title>
                            <span class="me-2"> ⏰ <small> {{ deadline.key }}</small></span>
                            <span v-if="deadline.exceeded" class="text-danger"> ‼️ {{
                                    $t('Deadline has been exceeded!!')
                                }}</span>
                            <span v-else class="text-warning"> ⚠️
                                {{
                                    $t('Please confirm the missing resource status before the deadline expires!')
                                }}</span>
                        </template>

                        <ul v-for="resourcegroup in deadline.resourcegroups" class="me-2" style="display:inline-flex;">
                            <li v-if="permissions.scmmodule && permissions.scmmodule.resources && permissions.scmmodule.resources.index">
                                <router-link
                                    :to="{name: 'resourcesIndex', query: {resourcegroups: [resourcegroup.id]}}"
                                    class="link-underline link-underline-opacity-0">
                                    {{ resourcegroup.name }}
                                </router-link>
                            </li>
                            <li v-else>
                                {{ resourcegroup.name }}
                            </li>
                        </ul>
                    </b-accordion-item>
                </b-accordion>
            </b-card-body>
        </b-card>
    </div>
    <div v-if="type_id === 801" class="mt-2 mb-2">
        <b-card class="w-100" header-tag="header">
            <template #header>
                <b-row>
                    <b-col class="col-12 text-start">
                        <span><small><i class="fas fa-traffic-light"></i> <b>{{ title }}</b></small></span>
                    </b-col>
                </b-row>
            </template>
            <b-card-body v-if="widgetData !== null">
                <div v-if="widgetData.cronjobStatus">
                    <b-row>
                        <b-col class="flex-1">
                            <div v-if="widgetData.cronjobStatus.total === 0">
                                <small class="fw-normal">
                                    <i class="fas fa-circle-info text-info"></i>
                                    {{ $t('No resource groups defined!') }}
                                </small>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div>
                                <div>
                                    <b-row>
                                        <div class="col col-12 col-md-6 col-lg-6">
                                            <b-row class="h-100 py-1 pe-3">
                                                <div class="col col-md-6 col-lg-6">
                                                    <small>{{ $t('Pending') }}</small>
                                                </div>
                                                <div :class="{'opacity-50': widgetData.cronjobStatus.pending === 0}"
                                                     class="col col-md-6 col-lg-6 text-primary text-start">
                                                    {{ widgetData.cronjobStatus.pending }}
                                                </div>
                                                <div class="col col-md-6 col-lg-6">
                                                    <small>{{ $t('Done') }}</small>
                                                </div>
                                                <div :class="{'opacity-50': widgetData.cronjobStatus.success === 0}"
                                                     class="col col-md-6 col-lg-6 text-success text-start">
                                                    {{ widgetData.cronjobStatus.success }}
                                                </div>
                                                <div class="col col-md-6 col-lg-6">
                                                    <small>{{ $t('Failed') }}</small>
                                                </div>
                                                <div :class="{'opacity-50': widgetData.cronjobStatus.failed === 0}"
                                                     class="col col-md-6 col-lg-6 text-danger text-start">
                                                    {{ widgetData.cronjobStatus.failed }}
                                                </div>
                                                <hr class="border-dashed m-0">
                                                <div class="col col-md-12 col-lg-12 text-primary text-end">
                                                    {{ $t('Total') }} {{ widgetData.cronjobStatus.total }}
                                                </div>
                                            </b-row>
                                        </div>

                                        <div
                                            :class="{'bg-primary-custom': (widgetData.cronjobStatus.total=== 0 || widgetData.cronjobStatus.pending > 0), 'bg-success':widgetData.cronjobStatus.total === widgetData.cronjobStatus.success, 'bg-danger': widgetData.cronjobStatus.failed > 0}"
                                            class="col col-12 col-md-6 col-lg-6 p-2 rounded overflow-hidden position-relative text-white mb-g text-center">
                                            <b-row>
                                                <div
                                                    class="col col-4 col-md-4 col-lg-4 border-end border-white border-2">
                                                    <h6 class="display-4 d-block l-h-n m-0 fw-500">
                                                        <router-link
                                                            v-if="widgetData.cronjobStatus.pending > 0 && (permissions.scmmodule && permissions.scmmodule.resourcegroups && permissions.scmmodule.resourcegroups.index)"
                                                            :to="{name: 'resourcegroupsIndex', query: {resourcegroups: widgetData.cronjobStatus.pendingIds}}"
                                                            class="link-underline link-underline-opacity-0 text-white">
                                                            {{ widgetData.cronjobStatus.pending }}
                                                        </router-link>
                                                        <div v-else>
                                                            {{ widgetData.cronjobStatus.pending }}
                                                        </div>
                                                    </h6>
                                                    <small class="m-0 l-h-n small">
                                                        {{ $t('Pending') }}
                                                    </small>
                                                </div>
                                                <div
                                                    class="col col-4 col-md-4 col-lg-4 border-end border-white border-2">
                                                    <h6 class="display-4 d-block l-h-n m-0 fw-500">
                                                        <router-link
                                                            v-if="widgetData.cronjobStatus.success > 0 && (permissions.scmmodule && permissions.scmmodule.resourcegroups && permissions.scmmodule.resourcegroups.index)"
                                                            :to="{name: 'resourcegroupsIndex', query: {resourcegroups: widgetData.cronjobStatus.successIds}}"
                                                            class="link-underline link-underline-opacity-0 text-white">
                                                            {{ widgetData.cronjobStatus.success }}
                                                        </router-link>
                                                        <div v-else>
                                                            {{ widgetData.cronjobStatus.success }}
                                                        </div>

                                                    </h6>
                                                    <small class="m-0 l-h-n small">
                                                        {{ $t('Done') }}
                                                    </small>
                                                </div>
                                                <div
                                                    class="col col-4 col-md-4 col-lg-4 border-end border-white border-2">
                                                    <h6 class="display-4 d-block l-h-n m-0 fw-500">
                                                        <router-link
                                                            v-if="widgetData.cronjobStatus.total > 0 && (permissions.scmmodule && permissions.scmmodule.resourcegroups && permissions.scmmodule.resourcegroups.index)"
                                                            :to="{name: 'resourcegroupsIndex', query: {resourcegroups: widgetData.cronjobStatus.totalIds}}"
                                                            class="link-underline link-underline-opacity-0 text-white">
                                                            {{ widgetData.cronjobStatus.total }}
                                                        </router-link>
                                                        <div v-else>
                                                            {{ widgetData.cronjobStatus.total }}
                                                        </div>

                                                    </h6>
                                                    <small class="m-0 l-h-n small">
                                                        {{ $t('Total') }}
                                                    </small>
                                                </div>
                                            </b-row>
                                        </div>
                                    </b-row>
                                    <b-accordion class="mx-0 mt-2">
                                        <b-accordion-item v-for="deadline in deadlines">
                                            <template #title>
                                                <span class="me-1">⏰ <small> {{ deadline.key }}</small></span>
                                                <span v-if="!deadline.exceeded && !deadline.timerangeArrives">
                                                    <i class="fas fa-hourglass-start text-info"></i>
                                                </span>
                                                <span
                                                    v-else-if="!deadline.exceeded && ( deadline.timerangeArrives && widgetData.cronjobStatus.pending > 0)">
                                                    <i class="fas fa-sync text-primary"></i>
                                                </span>
                                                <span
                                                    v-else-if="!deadline.exceeded && ( deadline.timerangeArrives && widgetData.cronjobStatus.pending === 0)">
                                                    <i class="fas fa-sync text-success"></i>
                                                </span>
                                                <span v-else-if="deadline.exceeded ">
                                                    <i v-if="widgetData.cronjobStatus.failed> 0"
                                                       class="fas fa-times text-danger"></i>
                                                    <i v-else class="fas fa-check text-success"></i>
                                                </span>
                                            </template>

                                            <ul v-for="resourcegroup in deadline.resourcegroups" class="me-2"
                                                style="display: inline-flex;">
                                                <li v-if="permissions.scmmodule && permissions.scmmodule.resourcegroups && permissions.scmmodule.resourcegroups.index">
                                                    <router-link
                                                        :to="{name: 'resourcegroupsIndex', query: {resourcegroups: [resourcegroup.id]}}"
                                                        class="link-underline link-underline-opacity-0">
                                                        {{ resourcegroup.name }}
                                                    </router-link>
                                                </li>
                                                <li v-else>
                                                    {{ resourcegroup.name }}
                                                </li>
                                            </ul>
                                        </b-accordion-item>
                                    </b-accordion>

                                </div>
                            </div>
                        </b-col>
                    </b-row>


                </div>
            </b-card-body>

        </b-card>

    </div>

</template>
<script>
import { BAccordion, BRow } from 'bootstrap-vue-next';

export default {
    name: "ScmWidget",
    components: {BAccordion, BRow},
    props: ['type_id', 'widget_id', 'title'],
    data() {
        return {
            widgetData: null,
            deadlines: [],
            permissions: {}
        }
    },

    mounted() {
        this.permissions = this.$store.state.permissions;
        this.getWidget();
    },

    methods: {
        getWidget: function() {
            if(this.type_id === 800) {
                axios.post('/dashboards/getScmWidget.json', null, {
                    params: {
                        id: this.widget_id
                    }
                }).then(result => {
                    this.widgetData = result.data.widgetData;
                    this.deadlines = result.data.widgetData.resources.deadlines;
                }).catch(error => {
                    console.log(error)
                });
            }
            if(this.type_id === 801) {
                axios.post('/dashboards/getScmCronjobs.json', null, {
                    params: {
                        id: this.widget_id
                    }
                }).then(result => {
                    this.widgetData = result.data.widgetData;
                    this.deadlines = result.data.widgetData.deadlines;
                }).catch(error => {
                    console.log(error)
                });
            }

        },
        toIndex: function(resources) {
            if(resources.length === 0) {
                return;
            }
            if(this.permissions.scmmodule && this.permissions.scmmodule.resources && this.permissions.scmmodule.resources.index) {
                this.$router.push({name: 'resourcesIndex', query: {resources: resources}});
            }
        },
        toResourcegroupsIndex: function(resourcegroups) {
            if(resourcegroups.length === 0) {
                return;
            }
            this.$router.push({name: 'resourcegroupsIndex', query: {resourcegroups: resourcegroups}});
        }

    }
}
</script>


<style scoped>
.numberCircle {
    border-radius: 50%;
    width: 70px;
    height: 70px;
    padding-top: 15px;

    /* background: #fff; */
    /* border: 4px solid #666; */
    color: #666;
    text-align: center;
    font-size: 1.0em;
    font-weight: bold;
}

.fsmall {
    font-weight: bold;
    font-size: 10px;
}

.flex-1 {
    flex: 1 !important;
}

</style>
